import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ExportService } from 'app/reports/services/export.service';
import { EMRService } from 'app/EMR/EMR.service';
import { takeUntil } from 'rxjs/operators';
import { MedicineMfgModal } from 'app/EMR/DoctorModels/medicineMfg.model';
import { LocationService } from 'app/masters/location-master/location.service';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-medicine-manufacturer-master',
  templateUrl: './medicine-manufacturer-master.component.html',
  styleUrls: ['./medicine-manufacturer-master.component.scss']
})
export class MedicineManufacturerMasterComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  private MfgMasterArrayList: any = [];
  private MfgMasterArray: any = [];
  private addMedicineMfg: MedicineMfgModal = {};
  showspinner: boolean;
  private searchMfgMaster: any;
  popbutton: number;


  constructor(private exportdata: ExportService, private emrService: EMRService, private locationService: LocationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MedicineManufacturerMasterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    }
    this.MfgMasterArray = [];
    this.MfgMasterArrayList = [];
    this.GetMedicineMfgMaster(0);
  }

  GetMedicineMfgMaster(medcineid) {
    this.MfgMasterArrayList = [];
    this.MfgMasterArray = [];
    this.emrService.GetMedicineMfgMaster(medcineid).pipe(takeUntil(this.destroy$)).subscribe(data => this.successMfgMaster(data), err => this.failed_category(err))
  }


  successMfgMaster(data) {
    this.MfgMasterArrayList = data;
    this.MfgMasterArray = data.filter(item => item.isActive == true);
    this.filterMfgList();
  }
  filteredMfgMasterArray: any[] = [];
  filterMfgList() {
    if (!this.searchMfgMaster) {
      this.filteredMfgMasterArray = this.MfgMasterArrayList;
    } else {
      const search = this.searchMfgMaster.toLowerCase();
      this.filteredMfgMasterArray = this.MfgMasterArrayList.filter(item =>
        item.manufacturerName?.toLowerCase().includes(search)
      );
    }
  }

  mgfCOmpany(mgfid) {
    let mgfName = this.MfgMasterArray.filter(item => item.pK_ManufacturerId == mgfid);
    if (mgfName.length > 0) {
      return mgfName[0].manufacturerName;
    } else {
      return null;
    }
  }

  failed_category(err) {

  }

  exportexcel(type: any, ctype: any): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById(ctype);
    this.exportdata.Newexportxcel(element, type);
  }

  medicineManufacturerSearchRecord() {
    document.getElementById("medicineManufactureSearchRecordModal").style.display = "block";
    this.GetMedicineMfgMaster(0);

  }
  cancelmedicineManufacturerSearchRecord() {
    document.getElementById("medicineManufactureSearchRecordModal").style.display = "none";
    this.searchMfgMaster = ''
  }
  selectMfglist(row: any) {
    this.addMedicineMfg = row;
    document.getElementById("medicineManufactureSearchRecordModal").style.display = "none";
  }



  addMfgCompany(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    this.showspinner = true;
    if (this.addMedicineMfg.pK_ManufacturerId == 0 || !this.addMedicineMfg.pK_ManufacturerId) {
      const existingManufacturer = this.MfgMasterArrayList.filter(manufacturer =>
        manufacturer.manufacturerName.toLowerCase() == this.addMedicineMfg.manufacturerName.toLowerCase()
      );

      if (existingManufacturer.length > 0) {
        this.locationService.openSnackBar("Already exists in the list", "OK");
        this.clearForm();
        this.showspinner = false;
        return;
      }
    }
    let payload = {
      "MedicineMfgMaster":
      {
        "IsEdit": this.addMedicineMfg.pK_ManufacturerId ? true : false, "IsDelete": false, "PK_ManufacturerId": this.addMedicineMfg.pK_ManufacturerId ? this.addMedicineMfg.pK_ManufacturerId : 0,
        "ManufacturerName": this.addMedicineMfg.manufacturerName, "IsActive": this.addMedicineMfg.isActive ? this.addMedicineMfg.isActive : false
      }
    }
    this.emrService.InsertMedicineMfgMaster(payload).pipe(takeUntil(this.destroy$)).subscribe((x: any) => {
      if (this.addMedicineMfg.pK_ManufacturerId > 0) {
        this.locationService.openSnackBar("Record updated successfully", "OK");
      } else {
        this.locationService.openSnackBar("Record saved successfully", "OK");
      }
      this.GetMedicineMfgMaster(0);
      this.addMedicineMfg = {};
      this.showspinner = false;
    }, err => {
      if (err.status == 403) {
        this.locationService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.locationService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.locationService.openSnackBar("API Failed", "OK");
      }
      this.showspinner = false;
      this.locationService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      if (this.popbutton > 0) {
        this.closedailog()
      }
    });
  }

  clearForm() {
    this.addMedicineMfg = {};
  }

  closedailog() {
    this.dialogRef.close();
  }
}
